export default __webpack_public_path__ + "static/mining-heritage-in-slovenia-c626d8ece4523b471d5684e618f14da8.pdf";